export default __webpack_public_path__ + "static/media/refercode_eamcet.ef0c6172.png";